export { default } from "./ServiceDesk";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/ServiceDesk/index.js